import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "side-menu" }
const _hoisted_2 = { class: "side-menu__add" }
const _hoisted_3 = { class: "side-menu__add-top" }
const _hoisted_4 = { class: "side-menu__add-title" }
const _hoisted_5 = { class: "side-menu__add-cards" }
const _hoisted_6 = { class: "side-menu__add-card-header" }
const _hoisted_7 = { class: "side-menu__add-card-name" }
const _hoisted_8 = ["alt"]
const _hoisted_9 = { class: "side-menu__add-card-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "side-menu__add-card-lock" }, null, -1)
const _hoisted_11 = { class: "side-menu__add-card-header" }
const _hoisted_12 = { class: "side-menu__add-card-name" }
const _hoisted_13 = { class: "side-menu__badge product-card-badge product-card-badge_announcement" }
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "side-menu__add-card-text" }

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElTooltip } from 'element-plus';
import { useStore } from 'vuex';
import IconPlus from '@/components/icons/Plus.vue';
import IconVideos from '@/components/icons/Videos.vue';
import IconDocs from '@/components/icons/Docs.vue';
import IconSystemReqs from '@/components/icons/SystemReqs.vue';
import IconCross from '@/components/icons/Cross.vue';
import { paths } from '@/constants/routes';
import { DocumentTypeEnum } from '@/types/manuals';
import ManualsGeneral from '@/components/Form/ManualsGeneral.vue';
import DialogSystemReq from '@/components/Form/DialogSystemReq.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const isMarketer = computed(() => store.getters.isMarketer);

const showCreateMenu = ref(false);
const isVideoDialogVisible = ref(false);
const isDocsDialogVisible = ref(false);
const isSystemReqVisible = ref(false);

watch(isVideoDialogVisible, () => {
  showCreateMenu.value = false;
});
watch(isDocsDialogVisible, () => {
  showCreateMenu.value = false;
});
watch(isSystemReqVisible, () => {
  showCreateMenu.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElTooltip), {
        popperClass: "side-menu__tooltip",
        effect: "light",
        content: _unref(t)('addApp'),
        rawContent: "",
        hideAfter: 0,
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "side-menu__item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateMenu.value = true))
          }, [
            _createVNode(IconPlus)
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_unref(ElTooltip), {
        popperClass: "side-menu__tooltip",
        effect: "light",
        content: _unref(t)('commonVideo'),
        rawContent: "",
        hideAfter: 0,
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "side-menu__item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isVideoDialogVisible.value = true))
          }, [
            _createVNode(IconVideos)
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_unref(ElTooltip), {
        popperClass: "side-menu__tooltip",
        effect: "light",
        content: _unref(t)('commonDocs'),
        rawContent: "",
        hideAfter: 0,
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "side-menu__item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isDocsDialogVisible.value = true))
          }, [
            _createVNode(IconDocs)
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_unref(ElTooltip), {
        popperClass: "side-menu__tooltip",
        effect: "light",
        content: _unref(t)('systemRequirements.abbreviated'),
        rawContent: "",
        hideAfter: 0,
        placement: "left"
      }, {
        default: _withCtx(() => [
          (!isMarketer.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "side-menu__item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (isSystemReqVisible.value = true))
              }, [
                _createVNode(IconSystemReqs)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"]),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('createProductCard')), 1),
          _createElementVNode("div", {
            class: "side-menu__add-close",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreateMenu.value = false))
          }, [
            _createVNode(IconCross)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(isMarketer.value ? 'span' : 'router-link'), {
            to: _unref(paths).addProduct,
            class: _normalizeClass(["side-menu__add-card", { locked: isMarketer.value }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('shop.product')), 1)
              ]),
              _createElementVNode("img", {
                class: "side-menu__add-card-img",
                src: "/img/example/product-card.jpg",
                alt: _unref(t)('imagesAlt.image')
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('someText1')), 1),
              (isMarketer.value)
                ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                    key: 0,
                    effect: "light",
                    content: _unref(t)('tooltipLockNewProduct'),
                    rawContent: "",
                    popperClass: "side-menu__add-card-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["to", "class"])),
          _createVNode(_component_router_link, {
            to: _unref(paths).addAnnouncement,
            class: "side-menu__add-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('labelAnnouncement')), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('labs.soon')), 1)
              ]),
              _createElementVNode("img", {
                class: "side-menu__add-card-img",
                src: "/img/example/product-card.jpg",
                alt: _unref(t)('imagesAlt.image')
              }, null, 8, _hoisted_14),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('someText2')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ], 512), [
        [_vShow, showCreateMenu.value]
      ]),
      (isVideoDialogVisible.value)
        ? (_openBlock(), _createBlock(ManualsGeneral, {
            key: 0,
            modelValue: isVideoDialogVisible.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isVideoDialogVisible).value = $event)),
            type: _unref(DocumentTypeEnum).Video,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (isVideoDialogVisible.value = false))
          }, null, 8, ["modelValue", "type"]))
        : _createCommentVNode("", true),
      (isDocsDialogVisible.value)
        ? (_openBlock(), _createBlock(ManualsGeneral, {
            key: 1,
            modelValue: isDocsDialogVisible.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isDocsDialogVisible).value = $event)),
            type: _unref(DocumentTypeEnum).Document,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (isDocsDialogVisible.value = false))
          }, null, 8, ["modelValue", "type"]))
        : _createCommentVNode("", true)
    ]),
    (isSystemReqVisible.value)
      ? (_openBlock(), _createBlock(DialogSystemReq, {
          key: 0,
          modelValue: isSystemReqVisible.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isSystemReqVisible).value = $event)),
          onClose: _cache[10] || (_cache[10] = ($event: any) => (isSystemReqVisible.value = false))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "side-menu__backdrop",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (showCreateMenu.value = false))
    }, null, 512), [
      [_vShow, showCreateMenu.value]
    ])
  ], 64))
}
}

})